export default function cleanObject(o) {
    for (let [key, value] of Object.entries(o)) {
      let propType = typeof(o[key]);
  
      //console.log(key, value, propType);
  
      switch (propType) {
        case "number" :
          o[key] = 0;
          break;
  
        case "string":
          o[key] = "";
          break;
  
        case "boolean":
          o[key] = false;    
          break;
        
        case "object":
          if( Array.isArray(value) ) {
            o[key] = [];
          } else {
            o[key] = {};
          }
          break;
  
        default:
          o[key] = undefined; 
          break;
      }
    }
  }
  